module.exports = __webpack_public_path__ + "static/media/2.7fdc37d4.jpg";